export default "__VITE_ASSET__MdrnV2L$__"